import { render, staticRenderFns } from "./CityContacts.vue?vue&type=template&id=c077b3f6&scoped=true"
import script from "./CityContacts.vue?vue&type=script&lang=js"
export * from "./CityContacts.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles-new/city.sass?vue&type=style&index=0&id=c077b3f6&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c077b3f6",
  null
  
)

export default component.exports